import {Component} from '@angular/core';
import {MatCardModule} from '@angular/material/card';

@Component({
  selector: 'app-app-mobile-prod',
  templateUrl: './app-mobile-prod.component.html',
  styleUrls: ['./app-mobile-prod.component.scss'],
  standalone: true,
  imports: [MatCardModule]
})
export class AppMobileProdComponent {}
